"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/VideoRooms/Modals/AddAdmins.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);
var _user = require('shared/selectors/user');
var _actions = require('web/actions'); var _actions2 = _interopRequireDefault(_actions);
var _Props = require('web/components/Form/Props');



var _hooks = require('web/services/hooks');
var _helpers = require('web/components/VideoRooms/Room/History/helpers');

var _AddAdmins = require('web/components/VideoRooms/Room/Modals/AddAdmins'); var _AddAdmins2 = _interopRequireDefault(_AddAdmins);

























const getInitialState = () => ({
  inputValues: { admins: '' },
  adminEntities: [],
})

// memo keeps the PureComponent / connect() bailout on unchanged props.
const AddAdminsModalContainer = _react.memo.call(void 0, function AddAdminsModalContainer ({
  isOpen, onClose, roomKey,
}) {
  // Existing behaviour kept: CurrentUserV2 declares no OrgKey, so this reads
  // undefined unless the server sends one; the JS read it all the same.
  const orgKey = _hooks.useAppSelector.call(void 0, state => {
    // SAFETY: widening only; the field is read as optional.
    const currentUser = _user.selectCurrentUserV2.call(void 0, state) 
    return currentUser.OrgKey
  })

  // Each handler builds its update from the committed state, as the class did
  // from `this.state`: two calls in one batch (the lookup's patient creation
  // removes then selects) each start from the same committed lists.
  const [state, setState, latest] = _helpers.useClassState(getInitialState)
  const { inputValues, adminEntities } = state

  const onAdminSelect = _react.useCallback.call(void 0, (admin) => {
    const { inputValues, adminEntities } = latest.current
    setState({
      inputValues: { ...inputValues, admins: '' },
      adminEntities: adminEntities.concat(admin),
    })
  }, [latest, setState])

  const onAdminUpdate = _react.useCallback.call(void 0, (updatedAdmin) =>
    setState({
      adminEntities: latest.current.adminEntities
        .filter(e => e.id !== updatedAdmin.id)
        .concat(updatedAdmin),
    }), [latest, setState])

  const onAdminRemove = _react.useCallback.call(void 0, (id) =>
    setState({
      adminEntities: latest.current.adminEntities.filter(e => e.id !== id),
    }), [latest, setState])

  const handleAdminsInputChange = _react.useCallback.call(void 0, (inputId, val) =>
    setState({
      inputValues: { ...latest.current.inputValues, [inputId]: val },
    }), [latest, setState])

  // Reads the committed lists, as the class read `this.state`.
  const onSubmit = () => {
    const { AdminUsers, AdminTeamKeys } = latest.current.adminEntities.reduce(
      (acc, e) => {
        if (e.type === _Props.ENTITY_TYPES.TEAM) {
          return {
            ...acc,
            AdminTeamKeys: acc.AdminTeamKeys.concat(e.id),
          }
        }
        return {
          ...acc,
          AdminUsers: acc.AdminUsers.concat({
            UserKey: e.id, OrgKey: e.orgKey,
          }),
        }
      }
      , { AdminUsers: [], AdminTeamKeys: [] },
    )

    _actions2.default.addVideoRoomAdmins({
      RoomKey: roomKey,
      AdminUsers,
      AdminTeamKeys,
    })
  }

  // componentDidUpdate: reset once the modal closes (before paint, as in the
  // class).
  const wasOpen = _react.useRef.call(void 0, isOpen)
  _react.useLayoutEffect.call(void 0, () => {
    if (wasOpen.current && !isOpen) setState(getInitialState())
    wasOpen.current = isOpen
  }, [isOpen, setState])

  return (
    _react2.default.createElement(_AddAdmins2.default, {
      isOpen: isOpen,
      onClose: onClose,
      adminsInputId: "admins",
      adminsInputValue: inputValues.admins,
      onAdminsInputChange: handleAdminsInputChange,
      onAdminSelect: onAdminSelect,
      onAdminUpdate: onAdminUpdate,
      onAdminRemove: onAdminRemove,
      adminEntities: adminEntities,
      onSubmit: onSubmit,
      orgKey: orgKey, __self: this, __source: {fileName: _jsxFileName, lineNumber: 121}}
    )
  )
})

exports. default = AddAdminsModalContainer
